module.exports = __webpack_public_path__ + "img/CAMBRI.ef9cea48.svg";